<template>
  <el-dialog :visible.sync="visible" :title="data ? '编辑品牌' : '新增品牌'" width="600px" @close="closeDialog">
    <el-form :model="form" label-width="90px" ref="form" :rules="rules">
      <el-form-item label="品牌名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入品牌名称" />
      </el-form-item>
      <el-form-item label="品牌图标">
        <el-upload
          class="upload-demo"
          :action="uploadUrl"
          :headers="uploadHeaders"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :before-upload="beforeUpload"
          :show-file-list="false"
          accept="image/*"
        >
          <div v-if="form.icon" class="image-preview">
            <img :src="getImageUrl(form.icon)" alt="品牌图标" style="width: 100px; height: 100px; object-fit: contain;" />
            <div class="image-overlay">
              <el-button size="small" type="primary">更换图标</el-button>
              <el-button size="small" type="danger" @click.stop="removeIcon">删除</el-button>
            </div>
          </div>
          <el-button v-else size="small" type="primary" icon="el-icon-upload">上传品牌图标</el-button>
        </el-upload>
        <div class="upload-tip">支持 jpg、png、gif、webp 格式，建议64x64像素，文件大小不超过 16MB</div>
      </el-form-item>
      <el-form-item label="品牌描述">
        <el-input type="textarea" v-model="form.description" placeholder="请输入品牌描述（可选）" :rows="3" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="submitting">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios';

export default {
  name: 'BrandForm',
  props: { 
    visible: Boolean, 
    data: Object 
  },
  data() {
    return {
      form: {
        name: '',
        icon: '',
        description: ''
      },
      submitting: false,
      rules: {
        name: [
          { required: true, message: '请输入品牌名称', trigger: 'blur' },
          { min: 1, max: 50, message: '品牌名称长度在1到50个字符', trigger: 'blur' }
        ],
        icon: [
          { required: true, message: '请输入图标URL', trigger: 'blur' }
        ]
      },
      uploading: false
    };
  },
  computed: {
    uploadUrl() {
      return 'https://app.homeliftbuy.com/api/upload';
    },
    uploadHeaders() {
      return {
        Authorization: localStorage.getItem('token')
      };
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.form = this.data ? { ...this.data } : { name: '', icon: '', description: '' };
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false);
      this.$refs.form.resetFields();
    },
    async onSubmit() {
      try {
        await this.$refs.form.validate();
        this.submitting = true;
        
        const headers = { Authorization: localStorage.getItem('token') };
        
        if (this.form.id) {
          await axios.put(`/api/admin/brand/${this.form.id}`, this.form, { headers });
          this.$message.success('修改成功');
        } else {
          await axios.post('/api/admin/brand', this.form, { headers });
          this.$message.success('新增成功');
        }
        
        this.$emit('refresh');
        this.closeDialog();
      } catch (error) {
        if (error.response) {
          this.$message.error('操作失败：' + (error.response.data.msg || '未知错误'));
        }
      } finally {
        this.submitting = false;
      }
    },
    // 上传前检查
    beforeUpload(file) {
      const isImage = file.type.indexOf('image/') === 0;
      const isLt16M = file.size / 1024 / 1024 < 16;
      
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt16M) {
        this.$message.error('上传图片大小不能超过 16MB!');
        return false;
      }
      
      this.uploading = true;
      return true;
    },
    // 上传成功
    handleUploadSuccess(response) {
      this.uploading = false;
      if (response.code === 0) {
        this.form.icon = response.data.url;
        this.$message.success('图标上传成功!');
      } else {
        this.$message.error(response.msg || '上传失败');
      }
    },
    // 上传失败
    handleUploadError() {
      this.uploading = false;
      this.$message.error('图标上传失败!');
    },
    // 删除图标
    removeIcon() {
      this.form.icon = '';
    },
    // 获取图片URL
    getImageUrl(url) {
      if (url.startsWith('http')) {
        return url;
      }
      return `https://app.homeliftbuy.com${url}`;
    }
  }
};
</script>

<style scoped>
.upload-demo {
  display: inline-block;
}

.image-preview {
  position: relative;
  display: inline-block;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  overflow: hidden;
}

.image-preview:hover .image-overlay {
  opacity: 1;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.3s;
}

.upload-tip {
  color: #999;
  font-size: 12px;
  margin-top: 8px;
  line-height: 1.4;
}
</style>